<template>
    <ui-report title="Company Statistics" subtitle="Get a snapshot of the activity within the company for a range of dates." :initial-filters="initialFilters">
        <template #default="{ filters }">

            <!-- New Packages. -->
            <reports-company-stats-fetch type="new_packages" :filters="filters" #default="{ loading, stat }">
                <reports-company-stats-card
                    class="col-span-full sm:col-span-6"
                    label="New Packages"
                    :value="stat ? stat.statistic : undefined"
                    :chart="stat ? stat.data_points : undefined"
                    :loading="loading"
                    href="/m/reports/packages"
                ></reports-company-stats-card>
            </reports-company-stats-fetch>

            <!-- Completed Packages. -->
            <reports-company-stats-fetch type="complete_packages" :filters="filters" #default="{ loading, stat }">
                <reports-company-stats-card
                    class="col-span-full sm:col-span-6"
                    label="Completed Packages"
                    :value="stat ? stat.statistic : undefined"
                    :chart="stat ? stat.data_points : undefined"
                    :loading="loading"
                    href="/m/reports/packages"
                ></reports-company-stats-card>
            </reports-company-stats-fetch>

            <!-- Sent Estimates. -->
            <reports-company-stats-fetch type="quotes_estimates" :filters="filters" #default="{ loading, stat }">
                <reports-company-stats-card
                    class="col-span-full sm:col-span-6"
                    label="Sent Estimates / Quotes"
                    :value="stat ? stat.statistic : undefined"
                    :secondary-value="stat ? toCurrency(stat.sum) : undefined"
                    :chart="stat ? stat.data_points : undefined"
                    :loading="loading"
                    href="/m/reports/sent-estimates"
                ></reports-company-stats-card>
            </reports-company-stats-fetch>
        </template>
    </ui-report>
</template>

<script>
import { toCurrency } from '@utils'

export default {
  data () {
        return {
            initialFilters: {
                range: 'since-monday',
            },
        }
    },
    methods: {
        toCurrency,
    },
}
</script>
